import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/system/inputstates", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setup(inputId, requestOptions) {
  return __request__("PUT", `/system/inputstates/setup/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function summary(requestOptions) {
  return __request__("GET", "/system/inputstates/summary", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(inputId, requestOptions) {
  return __request__("GET", `/system/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function start(inputId, requestOptions) {
  return __request__("PUT", `/system/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function stop(inputId, requestOptions) {
  return __request__("DELETE", `/system/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
